"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeMapTo = mergeMapTo;
exports.MergeMapToSubscriber = exports.MergeMapToOperator = void 0;

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _OuterSubscriber2 = require("../OuterSubscriber");

var _subscribeToResult = require("../util/subscribeToResult");

/* tslint:enable:max-line-length */

/**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */
function mergeMapTo(innerObservable, resultSelector) {
  var concurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Number.POSITIVE_INFINITY;

  if (typeof resultSelector === 'number') {
    concurrent = resultSelector;
    resultSelector = null;
  }

  return function (source) {
    return source.lift(new MergeMapToOperator(innerObservable, resultSelector, concurrent));
  };
} // TODO: Figure out correct signature here: an Operator<Observable<T>, R>
//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>


var MergeMapToOperator =
/*#__PURE__*/
function () {
  function MergeMapToOperator(ish, resultSelector) {
    var concurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Number.POSITIVE_INFINITY;
    (0, _classCallCheck2.default)(this, MergeMapToOperator);
    this.ish = ish;
    this.resultSelector = resultSelector;
    this.concurrent = concurrent;
  }

  (0, _createClass2.default)(MergeMapToOperator, [{
    key: "call",
    value: function call(observer, source) {
      return source.subscribe(new MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
    }
  }]);
  return MergeMapToOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */


exports.MergeMapToOperator = MergeMapToOperator;

var MergeMapToSubscriber =
/*#__PURE__*/
function (_OuterSubscriber) {
  (0, _inherits2.default)(MergeMapToSubscriber, _OuterSubscriber);

  function MergeMapToSubscriber(destination, ish, resultSelector) {
    var _this;

    var concurrent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Number.POSITIVE_INFINITY;
    (0, _classCallCheck2.default)(this, MergeMapToSubscriber);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MergeMapToSubscriber).call(this, destination));
    _this.ish = ish;
    _this.resultSelector = resultSelector;
    _this.concurrent = concurrent;
    _this.hasCompleted = false;
    _this.buffer = [];
    _this.active = 0;
    _this.index = 0;
    return _this;
  }

  (0, _createClass2.default)(MergeMapToSubscriber, [{
    key: "_next",
    value: function _next(value) {
      if (this.active < this.concurrent) {
        var resultSelector = this.resultSelector;
        var index = this.index++;
        var ish = this.ish;
        var destination = this.destination;
        this.active++;

        this._innerSub(ish, destination, resultSelector, value, index);
      } else {
        this.buffer.push(value);
      }
    }
  }, {
    key: "_innerSub",
    value: function _innerSub(ish, destination, resultSelector, value, index) {
      this.add((0, _subscribeToResult.subscribeToResult)(this, ish, value, index));
    }
  }, {
    key: "_complete",
    value: function _complete() {
      this.hasCompleted = true;

      if (this.active === 0 && this.buffer.length === 0) {
        this.destination.complete();
      }
    }
  }, {
    key: "notifyNext",
    value: function notifyNext(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
      var resultSelector = this.resultSelector,
          destination = this.destination;

      if (resultSelector) {
        this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
      } else {
        destination.next(innerValue);
      }
    }
  }, {
    key: "trySelectResult",
    value: function trySelectResult(outerValue, innerValue, outerIndex, innerIndex) {
      var resultSelector = this.resultSelector,
          destination = this.destination;
      var result;

      try {
        result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
      } catch (err) {
        destination.error(err);
        return;
      }

      destination.next(result);
    }
  }, {
    key: "notifyError",
    value: function notifyError(err) {
      this.destination.error(err);
    }
  }, {
    key: "notifyComplete",
    value: function notifyComplete(innerSub) {
      var buffer = this.buffer;
      this.remove(innerSub);
      this.active--;

      if (buffer.length > 0) {
        this._next(buffer.shift());
      } else if (this.active === 0 && this.hasCompleted) {
        this.destination.complete();
      }
    }
  }]);
  return MergeMapToSubscriber;
}(_OuterSubscriber2.OuterSubscriber);

exports.MergeMapToSubscriber = MergeMapToSubscriber;